import { css } from '@emotion/react';
import LocalizedMessage from './LocalizedMessage';
import ResponsiveTooltip from './ResponsiveTooltip';
import useMessageService from '../services/i18n/useMessageService';

const InsecurePasswordMessage = () => {
    const [
        [
            learnMore = 'Learn More',
            insecurePassword = 'Please use a more secure password.',
            insecurePasswordMore = "To protect your account, we check if the password you've tried to set has previously appeared in an Internet data breach.",
        ],
    ] = useMessageService([
        'general.learn_more',
        'error.veevaid_insecure_password',
        'error.veevaid_insecure_password_more',
    ]);

    return (
        <LocalizedMessage
            template={`${insecurePassword} {0}`}
            tokens={[
                <ResponsiveTooltip
                    key={learnMore}
                    content={<div>{insecurePasswordMore}</div>}
                    placement="bottom"
                >
                    <span
                        css={({ linkBlue }) => css`
                            color: ${linkBlue};
                        `}
                    >
                        {learnMore}
                    </span>
                </ResponsiveTooltip>,
            ]}
        />
    );
};

export default InsecurePasswordMessage;
